import { ContactsApiProvider } from './contactsapi.services';

const setOutOfOffice = (memberKey, dates) => {
  return ContactsApiProvider.post(`/members/${memberKey}/outofoffices`, dates);
};

/// members/{memberKey}/outofoffices/{outofofficekey}
const updateOutOfOffice = (outOfOfficeKeys, outOfOfficeData) => {
  return ContactsApiProvider.put(`/members/${outOfOfficeKeys.memberKey}/outofoffices/${outOfOfficeKeys.outOfOfficeKey}`, outOfOfficeData);
};

const deleteOutOfOffice = (memberKey, outofofficekey) => {
  return ContactsApiProvider.delete(`/members/${memberKey}/outofoffices/${outofofficekey}`);
};

export const UserProfileApiProvider = {
  setOutOfOffice,
  updateOutOfOffice,
  deleteOutOfOffice
};
